import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Dashboard from "./Dashboard";
import { getUserLocalData } from "../lib/helper";


const generateCodeVerifier = () => {
  return window.crypto.getRandomValues(new Uint8Array(32)).toString();
};

const generateCodeChallenge = async (verifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};
const QRLogin = () => {
  const [authUrl, setAuthUrl] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  // const params1=useSearchParams();
  useEffect(() => {
    localStorage.setItem("ref", 'qr');
    const initAuthProcess = async () => {
      const verifier = generateCodeVerifier();
      localStorage.setItem("verifier", verifier);

      const launch = searchParams.get("launch");
      const challenge = await generateCodeChallenge(verifier);
      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_CLIENT_ID,
        aud: process.env.REACT_APP_MELDRX_WS_URL,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        scope: "openid offline_access fhirUser user/*.read user/*.*",
        response_type: "code",
        code_challenge: challenge,
        code_challenge_method: "S256",
      })

      if (launch) {
        params.append('launch', launch)
      }

      const authLink = `${process.env.REACT_APP_MELDRX_BASE_URL}/connect/authorize?${params.toString()}`;
      setAuthUrl(authLink);
      window.location.href = authLink; // Redirect after setting state
    };

    initAuthProcess();
  }, []);

  return null
};

export default QRLogin;
